import React, { useEffect, useState } from "react";
import { Form, Row, Col, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getstudentFeesDetails } from "../../store/slices/fees";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getStudent } from "../../store/slices/student";


export default function OpeningBalance() {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const [errors, setErrors] = useState({});
  const sessions = Array.from({ length: 2 }, (_, index) => {
    const startYear = currentYear - 1 + index;
    const endYear = String(startYear + 1).slice(-2);

    return `${startYear}-${endYear}`;
  });

  const [session, setSession] = useState("");
  const [standardId, setStandardId] = useState("");
  const [studentId, setStudentId] = useState("");
  const [sectionId, setSectionId] = useState("");

  const [standards, setStandards] = useState([]);
  const [students, setStudents] = useState([]);
  const [sections, setSections] = useState([]);

  const [feeDetails, setFeeDetails] = useState([]);


  useEffect(() => {

    dispatch(fetchStandardSection())
      .unwrap()
      .then((res) => {

        setStandards(res.data || []);

      })
      .catch((err) => {

        toast.error(err);

      });

  }, []);
  const validate = () => {
    const newErrors = {};

    if (!session) {
      newErrors.session = "Please select session";
    }

    if (!standardId) {
      newErrors.standardId = "Please select standard";
    }

    if (!sectionId) {
      newErrors.sectionId = "Please select section";
    }

    if (!studentId) {
      newErrors.studentId = "Please select student";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleStandardChange = (e) => {

    const value = e.target.value;

    setStandardId(value);

    setSectionId("");

    setStudentId("");

    setStudents([]);

    setFeeDetails([]);

    const selectedStandard = standards.find(
      item => item.standardId._id === value
    );

    if (selectedStandard) {
      setSections(selectedStandard.sectionId);
    } else {
      setSections([]);
    }

  };

  const handleSectionChange = (e) => {

    const value = e.target.value;

    setSectionId(value);

    setStudentId("");

    setFeeDetails([]);

    dispatch(getStudent({
      standardId,
      sectionId: value
    }))
      .unwrap()
      .then((res) => {

        setStudents(res.data || []);

      })
      .catch((err) => {

        toast.error(err);

      });

  };

  const handleStudentChange = (e) => {

    setStudentId(e.target.value);

    setFeeDetails([]);

  };
  const handleSearch = () => {
    if (!validate()) return;

    dispatch(
      getstudentFeesDetails({
        session,
        studentId,
      })
    )
      .unwrap()
      .then((res) => {
        setFeeDetails(res.data);
      })
      .catch((err) => {
        toast.error(err);
      });
  };
  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/accounts/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>



            <FiChevronRight className="separator" />

            <span className="active">Opening Balance</span>
          </div>
        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSearch}>
          <Row className="g-3">

            {/* Session */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Session</Form.Label>
                <Form.Select
                  value={session}

                  onChange={(e) => {
                    setSession(e.target.value);
                    setErrors((prev) => ({
                      ...prev,
                      session: "",
                    }));
                  }}
                >
                  <option value="">Select Session</option>

                  {sessions.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </Form.Select>

                {errors.session && (
                  <div className="text-danger mt-1">{errors.session}</div>
                )}
              </Form.Group>
            </Col>

            {/* Standard */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>

                <Form.Select
                  value={standardId}

                  onChange={(e) => {
                    handleStandardChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      standardId: "",
                    }));
                  }}
                >
                  <option value="">Select Standard</option>

                  {standards.map((item) => (
                    <option
                      key={item.standardId._id}
                      value={item.standardId._id}
                    >
                      {item.standardId.name}
                    </option>
                  ))}
                </Form.Select>

                {errors.standardId && (
                  <div className="text-danger mt-1">
                    {errors.standardId}
                  </div>
                )}
              </Form.Group>
            </Col>

            {/* Section */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Section</Form.Label>

                <Form.Select
                  value={sectionId}
                  disabled={!standardId}

                  onChange={(e) => {
                    handleSectionChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      sectionId: "",
                    }));
                  }}
                >
                  <option value="">Select Section</option>

                  {sections.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>

                {errors.sectionId && (
                  <div className="text-danger mt-1">
                    {errors.sectionId}
                  </div>
                )}
              </Form.Group>
            </Col>

            {/* Student */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Student</Form.Label>
                <Form.Select
                  value={studentId}
                  disabled={!sectionId}

                  onChange={(e) => {
                    handleStudentChange(e);
                    setErrors((prev) => ({
                      ...prev,
                      studentId: "",
                    }));
                  }}
                >
                  <option value="">Select Student</option>

                  {students.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>

                {errors.studentId && (
                  <div className="text-danger mt-1">
                    {errors.studentId}
                  </div>
                )}
              </Form.Group>
            </Col>

          </Row>

          <Row className="mt-5">
            <Col className="d-flex justify-content-center">
              <button
                type="button"
                className="btn-submit" style={{ width: "150px" }}
                onClick={handleSearch}
              >
                Search
              </button>
            </Col>

          </Row>

          {feeDetails.length > 0 && (

            <div className="mt-4">

              {feeDetails.map((category) => (

                <div
                  key={category.feeCategoryId}
                  className="mb-5"
                >

                  <div className="table-responsive mt-5">

                    <Table className="staff-table align-middle">

                      <thead className="table-light">

                        <tr>

                          <th className="text-center">
                            Installment
                          </th>

                          <th className="text-center">
                            Due Date
                          </th>

                          <th className="text-center">
                            Amount
                          </th>

                          <th className="text-center">
                            Paid
                          </th>

                          <th className="text-center">
                            Discount
                          </th>

                          <th className="text-center">
                            Due
                          </th>

                          <th className="text-center">
                            Status
                          </th>




                        </tr>

                      </thead>

                      <tbody>

                        {category.installments.map((item, index) => (

                          <tr key={index}>

                            <td className="text-center">{item.installmentName}</td>

                            <td className="text-center">
                              {new Date(item.dueDate).toLocaleDateString()}
                            </td>

                            <td className="text-center">₹{item.amount}</td>

                            <td className="text-center">₹{item.paid}</td>

                            <td className="text-center">₹{item.discount}</td>

                            <td className="text-center">₹{item.due}</td>

                            <td className="text-center">

                              <span
                                className={
                                  item.status === "Paid"
                                    ? "badge bg-success"
                                    : item.status === "Partial"
                                      ? "badge bg-warning"
                                      : "badge bg-danger"
                                }
                              >
                                {item.status}
                              </span>

                            </td>


                          </tr>

                        ))}

                      </tbody>

                    </Table>

                  </div>

                </div>

              ))}

            </div>

          )}
        </Form>
      </div>
    </>
  );
}